import ReportStackRanks from './ReportStackRanks'
export default ReportStackRanks